export const demoPreview = {
  badgeLabel: 'Demo preview',
  bannerMessage:
    'Unsolicited complimentary concept by JMR Squared. This is not the official website for this business. We remove it on request, or within 2 weeks.',
  attributionCreditLabel: 'Unsolicited demo preview by',
  attributionContext:
    'This demo was built to show what a dedicated website could look like. It is not affiliated with or endorsed by the business unless they choose to keep it.',
} as const;
